module.exports = __webpack_public_path__ + "img/cmp_content_img_03.b8cd0cab.png";